module.exports = __webpack_public_path__ + "img/Roxe_eGC.35cd40af.png";